import { render } from "./Section_Payables.vue?vue&type=template&id=2694bc73"
import script from "./Section_Payables.vue?vue&type=script&lang=js"
export * from "./Section_Payables.vue?vue&type=script&lang=js"

import "./Section_Payables.vue?vue&type=style&index=0&id=2694bc73&lang=css"
script.render = render

export default script